module.exports = __webpack_public_path__ + "static/media/yellowHandRaise.7a313bfc.svg";